<template>
  <div>
    <v-app-bar
        app
        flat
        height="76"
        color="white"
        class="site-header"
        :class="{ 'site-header--scrolled': scrolled }"
        v-scroll="onScroll"
    >
      <div class="site-header__inner">
        <router-link to="/" class="site-header__logo" @click.native="onLogoClick">
          <img :src="require('@/assets/2023/prdays-logo-2023.svg')" alt="PR, Media & Sports Days University of Mostar"/>
        </router-link>

        <nav class="site-nav" aria-label="Glavna navigacija">
          <a
              v-for="item in $t('items')"
              :key="item.title"
              :href="itemHref(item)"
              class="site-nav__link"
              :class="{ 'is-active': isActive(item) }"
              @click.prevent="go(item)"
          >{{ item.title }}</a>
        </nav>

        <div class="site-header__actions">
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <button class="site-lang" v-on="on" type="button" :aria-label="'Jezik: ' + $i18n.locale">
                <img :src="$t('flag')" alt=""/>
                <span>{{ $i18n.locale.toUpperCase() }}</span>
                <v-icon small>mdi-chevron-down</v-icon>
              </button>
            </template>
            <v-list dense class="py-1">
              <v-list-item v-for="entry in languages" :key="entry.language" @click="changeLocale(entry)">
                <img :src="entry.flag" alt="" class="site-lang__flag"/>
                <v-list-item-title>{{ entry.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <button class="site-nav-toggle" type="button" aria-label="Izbornik" @click.stop="drawer = !drawer">
            <v-icon>mdi-menu</v-icon>
          </button>
        </div>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app temporary right width="300" class="site-drawer">
      <div class="site-drawer__head">
        <img :src="require('@/assets/2023/prdays-logo-2023.svg')" alt="PR, Media & Sports Days"/>
        <button class="site-nav-toggle d-flex" type="button" aria-label="Zatvori" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <nav class="site-drawer__nav">
        <a
            v-for="item in $t('items')"
            :key="item.title"
            :href="itemHref(item)"
            class="site-drawer__link"
            :class="{ 'is-active': isActive(item) }"
            @click.prevent="go(item)"
        >
          <v-icon size="20">{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </a>
      </nav>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  data: () => ({
    drawer: false,
    scrolled: false,
    activeSection: null,
    languages: [
      {language: "hr", title: "Hrvatski", flag: require("@/assets/img/cro.png")},
      {language: "en", title: "English", flag: require("@/assets/img/uk.png")},
    ],
  }),
  computed: {
    onHome() {
      return this.$route.path === '/';
    },
  },
  mounted() {
    this.onScroll();
  },
  methods: {
    itemHref(item) {
      return item.router ? item.router : '/' + item.link;
    },
    isActive(item) {
      if (item.router) return this.$route.path.indexOf(item.router) === 0;
      return this.onHome && this.activeSection === item.link;
    },
    go(item) {
      this.drawer = false;
      if (item.router) {
        if (this.$route.path !== item.router) this.$router.push(item.router);
        return;
      }
      if (this.onHome) {
        this.$scrollTo(item.link);
      } else {
        this.$router.push({path: '/', hash: item.link});
      }
    },
    onLogoClick() {
      if (this.onHome) window.scrollTo({top: 0, behavior: 'smooth'});
    },
    onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.scrolled = y > 8;
      this.$emit('scrolled', y > 300);
      if (!this.onHome) return;
      let current = null;
      this.$t('items').forEach(item => {
        if (!item.link) return;
        const el = document.querySelector(item.link);
        if (el && el.getBoundingClientRect().top <= 140) current = item.link;
      });
      this.activeSection = current;
    },
    changeLocale(entry) {
      this.$i18n.locale = entry.language;
      localStorage.setItem("language", entry.language);
      document.documentElement.setAttribute('lang', entry.language);
      this.$emit('locale-change', entry.language);
    },
  },
};
</script>

<style lang="scss">
.site-header.v-app-bar.v-toolbar {
  border-bottom: 1px solid transparent;
  transition: box-shadow .25s ease, border-color .25s ease;

  .v-toolbar__content {
    padding: 0;
  }
}

.site-header--scrolled.v-app-bar.v-toolbar {
  border-bottom-color: var(--pr-line);
  box-shadow: 0 6px 24px rgba(0, 38, 82, .08) !important;
}

.site-header__inner {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: var(--pr-max);
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
}

.site-header__logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  img {
    height: 52px;
    width: auto;
    display: block;
  }
}

.site-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.site-nav__link {
  position: relative;
  padding: 10px 12px;
  border-radius: 8px;
  color: var(--pr-ink) !important;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  transition: color .2s ease, background-color .2s ease;

  &::after {
    content: "";
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 2px;
    height: 2px;
    border-radius: 2px;
    background: var(--pr-red);
    transform: scaleX(0);
    transition: transform .25s ease;
  }

  &:hover {
    color: var(--pr-navy) !important;
    background: var(--pr-bg);
  }

  &.is-active {
    color: var(--pr-navy) !important;

    &::after {
      transform: scaleX(1);
    }
  }
}

.site-header__actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.site-lang {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px 6px 6px;
  border: 1px solid var(--pr-line);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: var(--pr-ink);
  background: #fff;
  transition: border-color .2s ease;

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
  }

  &:hover {
    border-color: var(--pr-navy);
  }
}

.site-lang__flag {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 50%;
}

.site-nav-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;

  &:hover {
    background: var(--pr-bg);
  }
}

.site-drawer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 76px;
  padding: 0 12px 0 20px;
  border-bottom: 1px solid var(--pr-line);

  img {
    height: 44px;
  }
}

.site-drawer__nav {
  display: flex;
  flex-direction: column;
  padding: 12px;
}

.site-drawer__link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  color: var(--pr-ink) !important;
  font-weight: 600;
  text-decoration: none;

  .v-icon {
    color: var(--pr-muted) !important;
  }

  &:hover {
    background: var(--pr-bg);
  }

  &.is-active {
    background: rgba(0, 38, 82, .07);
    color: var(--pr-navy) !important;

    .v-icon {
      color: var(--pr-red) !important;
    }
  }
}

@media (max-width: 1200px) {
  .site-nav {
    display: none;
  }
  .site-header__actions {
    margin-left: auto;
  }
  .site-nav-toggle {
    display: inline-flex;
  }
}

@media (max-width: 600px) {
  .site-header__inner {
    padding: 0 12px 0 16px;
  }
  .site-header__logo img {
    height: 44px;
  }
}
</style>
